import { ReactNode } from 'react';

export interface IconProps {
  className: string;
}

interface IconFrameProps extends IconProps {
  children: ReactNode;
}

function IconFrame(props: IconFrameProps): JSX.Element {
  return (
    <svg className={props.className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}
      strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      {props.children}
    </svg>
  );
}

export function TagIcon(props: IconProps): JSX.Element {
  return (
    <IconFrame className={props.className}>
      <path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z" />
      <circle cx="7.5" cy="7.5" r="1.5" />
    </IconFrame>
  );
}

export function HeartIcon(props: IconProps): JSX.Element {
  return (
    <IconFrame className={props.className}>
      <path d="M19.5 12.6 12 20l-7.5-7.4A5 5 0 0 1 12 6a5 5 0 0 1 7.5 6.6Z" />
    </IconFrame>
  );
}

export function ChartIcon(props: IconProps): JSX.Element {
  return (
    <IconFrame className={props.className}>
      <path d="M3 3v18h18" />
      <path d="m7 15 4-4 3 3 6-6" />
      <path d="M16 8h4v4" />
    </IconFrame>
  );
}

export function BoltIcon(props: IconProps): JSX.Element {
  return (
    <IconFrame className={props.className}>
      <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z" />
    </IconFrame>
  );
}
